import { WorkContactsDatatable } from "datatables/work_templates"
export default class WorkContactsIndex extends ApplicationController {
  connect () {
    this.datatable = new WorkContactsDatatable()
  }
}